// extracted by mini-css-extract-plugin
export var aboveInput = "_lf-0";
export var actionButton = "_lf-5";
export var actionButtonContainer = "_lf-1";
export var actionIcon = "_lf-6";
export var aiInfoContainer = "_lf-2";
export var attachmentWrapper = "_lf-7";
export var bold = "_lf-3";
export var checkIcon = "_lf-8";
export var clickingRecipientBar = "_lf-11";
export var commentThreadSwitch = "_lf-a";
export var draftImage = "_lf-b";
export var draftImageContainer = "_lf-c";
export var draftImages = "_lf-e";
export var editButton = "_lf-g";
export var editor = "_lf-f";
export var editorContainer = "_lf-y";
export var editorErrorTooltipWrapper = "_lf-9";
export var headerDivider = "_lf-h";
export var icon = "_lf-i";
export var info = "_lf-j";
export var internal = "_lf-n";
export var internalDivider = "_lf-k";
export var internalMessage = "_lf-l";
export var messageInputCard = "_lf-m";
export var messageInputForm = "_lf-o";
export var messageInputFormInternal = "_lf-p";
export var options = "_lf-q";
export var publicMessageCustomer = "_lf-s";
export var publicMessageMerchant = "_lf-r";
export var removeImageButton = "_lf-d";
export var replyButtons = "_lf-t";
export var showSignatureButton = "_lf-u";
export var spinner = "_lf-v";
export var verticalButtonDivider = "_lf-4";
export var visibilitySelector = "_lf-w";
export var warning = "_lf-x";
export var wrappingText = "_lf-z";
export var writingInternalNoteTopBorder = "_lf-10";